import { Injectable } from '@angular/core';
import { IID_RISORSE_CREATION } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDRisorseCreationQuery } from './iidRisorseCreation.query';
import { IIDRisorseCreationStore } from './iidRisorseCreation.store';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.RISORSE_CREATION)
export class IIDRisorseCreationService extends CrudService<IID_RISORSE_CREATION, IIDRisorseCreationStore, IIDRisorseCreationQuery> {

  constructor(
    protected store: IIDRisorseCreationStore,
    public query: IIDRisorseCreationQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
  ) {
    super(
      Topics.IID_RISORSE_CREATION,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }
}
